import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'public-layout',
    templateUrl: 'public.layout.html',
})
export class PublicLayout implements OnInit {

    constructor() { }

    ngOnInit() { }
}